// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface INmvtisVehiclePartStolenType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class NmvtisVehiclePartStolenType implements INmvtisVehiclePartStolenType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Moped RegistrationType
	**/
    get MajorComponent(): INmvtisVehiclePartStolenType {
        return this.FromId(1);
    }
    /**
		Returns Arizona Registration Only RegistrationType
	**/
    get BodyNumber(): INmvtisVehiclePartStolenType {
        return this.FromId(2);
    }
    /**
		Returns SPI RegistrationType
	**/
    get Chassis(): INmvtisVehiclePartStolenType {
        return this.FromId(3);
    }
    /**
		Returns Regular RegistrationType
	**/
    get CrankCase(): INmvtisVehiclePartStolenType {
        return this.FromId(4);
    }

    get CrankCaseReplacement(): INmvtisVehiclePartStolenType {
        return this.FromId(5);
    }

    get Engine(): INmvtisVehiclePartStolenType {
        return this.FromId(6);
    }

    get ReplacementEngine(): INmvtisVehiclePartStolenType {
        return this.FromId(7);
    }

    get Frame(): INmvtisVehiclePartStolenType {
        return this.FromId(8);
    }

    get ReplacementFrame(): INmvtisVehiclePartStolenType {
        return this.FromId(9);
    }

    get VINPlate(): INmvtisVehiclePartStolenType {
        return this.FromId(10);
    }

    get OtherNotAMajorComponentPart(): INmvtisVehiclePartStolenType {
        return this.FromId(11);
    }

    get NotProvidedByStolenPartsDescription(): INmvtisVehiclePartStolenType {
        return this.FromId(12);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        // refer bug 51997
        // this._dictionary.add("1", { id: 1, value: "MajorComponent", displayValue: "Major component", description: "Major component", sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'BodyNumber', displayValue: 'Body Number', description: 'Body Number', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'Chassis', displayValue: 'Chassis', description: 'Chassis', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'CrankCase', displayValue: 'Crank Case', description: 'Crank Case', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'CrankCaseReplacement', displayValue: 'Crank Case Replacement', description: 'Crank Case Replacement', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'Engine', displayValue: 'Engine', description: 'Engine', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'ReplacementEngine', displayValue: 'Replacement Engine', description: 'Replacement Engine', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'Frame', displayValue: 'Frame', description: 'Frame', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'ReplacementFrame', displayValue: 'Replacement Frame', description: 'Replacement Frame', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'VINPlate', displayValue: 'VIN Plate', description: 'VIN Plate', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'Other-NotAMajorComponentPart', displayValue: 'Other - Not a major component part', description: 'Other - Not a major component part', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, value: 'NotProvidedByStolenPartsDescription', displayValue: 'Not provided by Stolen Parts Description', description: 'Not provided by Stolen Parts Description', sortOrder: 12, active: true });

    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): INmvtisVehiclePartStolenType {
        return this._dictionary[id];
    }

    public FromValue(value: string): INmvtisVehiclePartStolenType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): INmvtisVehiclePartStolenType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): INmvtisVehiclePartStolenType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): INmvtisVehiclePartStolenType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
